import React from 'react';
import { connect } from 'react-redux';
import { searchWizardPage } from '../../../consts/pageTypes';
import { IFooter } from '../../../interfaces/IFooter';
import { IState } from '../../../reducers';
import { IBrandConfig } from '../../../reducers/pageData';
import { Newsletter } from '../../Newsletter/Newsletter';
import { FooterBottom } from './FooterBottom';
import { FooterNav } from './FooterNav';
import { FooterUSP } from './FooterUSP';

interface IProps {
    footer: IFooter;
    brandConfig: IBrandConfig;
    pageType: string;
}

export class FooterDesktopComponent extends React.Component<IProps> {
    render() {
        const showCondensedFooter = Boolean(this.props.pageType === searchWizardPage);
        if (showCondensedFooter) {
            return (
                <footer className="footer search-wizard container-fluid">
                    <FooterBottom
                        className="footer_bottomBar row"
                        list={this.props.footer.bottom}
                    />
                </footer>
            );
        } else {
            return (
                <div>
                    <footer className="footer container-fluid">
                        <Newsletter location="footer" />
                        <FooterUSP />
                        <FooterNav
                            brandConfig={this.props.brandConfig}
                            footer={this.props.footer}
                            pageType={this.props.pageType}
                        />

                        <FooterBottom
                            className="footer_bottomBar row"
                            list={this.props.footer.bottom}
                        />
                    </footer>
                </div>
            );
        }
    }
}

const mapStateToProps = (state: IState) => ({
    footer: state.pageData.footer,
    brandConfig: state.pageData.brandConfig,
    pageType: state.router.pageType,
});

export const FooterDesktop = connect(mapStateToProps, {})(FooterDesktopComponent);
